import styled from "styled-components";

export const Form = styled.form`
    width: 280px;
    margin-bottom: 1rem;
`;
